(() => {
  function mount(root) {
    if (root.dataset.edMounted) return;
    root.dataset.edMounted = 'true';
    const dialog = root.querySelector('dialog');
    let opener, previousOverflow;
    const select = name => {
      dialog.querySelectorAll('[data-ed-panel]').forEach(p => p.hidden = p.dataset.edPanel !== name);
      dialog.querySelectorAll('[data-ed-tab]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.edTab === name)));
      dialog.querySelector('h2').textContent = name === 'sort' ? 'Sort by' : 'Filter';
    };
    root.querySelectorAll('[data-ed-open]').forEach(button => button.addEventListener('click', () => {
      opener = button; select(button.dataset.edOpen);
      previousOverflow = document.body.style.overflow;
      dialog.showModal(); document.body.style.overflow = 'hidden';
    }));
    dialog.querySelectorAll('[data-ed-tab]').forEach(b => b.addEventListener('click', () => select(b.dataset.edTab)));
    dialog.querySelector('[data-ed-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
    dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; opener?.focus(); });
    dialog.querySelectorAll('[data-ed-panel="sort"] input[type="radio"]').forEach(input => input.addEventListener('change', () => input.form.requestSubmit()));
    root.querySelectorAll('[data-ed-preserve-view],.ed-pagination a').forEach(a => { const url = new URL(a.href); url.searchParams.set('view', root.dataset.edView); a.href = url.href; });
  }
  document.querySelectorAll('[data-ed-catalogue]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ed-catalogue]').forEach(mount));
})();
